'use client';

import { cn } from '@/lib/utils';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FC, useRef } from 'react';

interface TextRevealProps {
    children: string;
    className?: string;
    start?: number;
    end?: number;
}

export const TextReveal: FC<TextRevealProps> = ({
    children,
    className,
    start = 0.05,
    end = 0.8,
}) => {
    const ref = useRef<HTMLSpanElement>(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start 35%', 'end 1%'],
    });

    if (typeof children !== 'string') {
        throw new Error('TextReveal: children must be a string');
    }

    const words = children.split(' ');
    const total = words.length;
    const step = (end - start) / total;

    return (
        <span
            ref={ref}
            className={cn(
                'relative inline leading-tight break-words whitespace-normal',
                className,
            )}
        >
            {words.map((word, i) => {
                const wordStart = start + step * i;
                const wordEnd = wordStart + step;

                // Smooth transition from gray to black

                // TODO: @I-am-Lemuel Fix the eslint error properly

                // eslint-disable-next-line react-hooks/rules-of-hooks
                const opacity = useTransform(
                    scrollYProgress,
                    [wordStart, wordEnd],
                    [0.2, 1],
                );

                // eslint-disable-next-line react-hooks/rules-of-hooks
                const color = useTransform(
                    scrollYProgress,
                    [wordStart, wordEnd],
                    ['#999', '#000'],
                );

                return (
                    <span key={i} className="relative mr-[0.25ch] inline-block">
                        <motion.span
                            style={{ opacity, color }}
                            transition={{
                                type: 'spring',
                                damping: 20,
                                stiffness: 100,
                            }}
                            className="inline-block"
                        >
                            {word}
                        </motion.span>
                    </span>
                );
            })}
        </span>
    );
};
